'use strict';


angular.module('cvsApp')
    .factory('requestService', ['$rootScope', '$window', 'serviceFactory', '$timeout', 'help', '$http', '$q','paymentAppData','networkService',
    function ($rootScope, $window, serviceFactory, $timeout, help, $http, $q,paymentAppData,networkService) {

        var makeRequest, baseUrl, serviceEndPoints = "serviceEndPoints", apiParamData;
        if (help.IEVersion() == 8) {
            makeRequest = function (serviceEndPoint, params, data) {
                var xdr = new $window.XDomainRequest();
                var x2js = new X2JS();
                var deferred = $q.defer();
                $timeout(function () {
                   // angular.element("#LoadingImage").show();
                    showProgress('block');
                    if (xdr) {
                        //event raised when there is an error that prevents the completion of
                        // the cross-domain request.
                        xdr.onerror = function () {
                            $rootScope.$apply(function () {
                                deferred.reject(xdr.responseText);
                                showProgress('none');
                            });
                        };

                        //Raised when the object has been completely received from the server.
                        xdr.onload = function () {
                            $rootScope.$apply(function () {
                                var jsondata;
                                if (xdr.responseText) {
                                    var x2js = new X2JS();
                                    jsondata = x2js.xml_str2json(xdr.responseText);
                                    deferred.resolve(jsondata);
                                    //angular.element("#LoadingImage").hide();
                                    showProgress('none');
                                } else {
                                    showProgress('none');
                                    jsondata = "No Response Object";
                                }
                            });
                        };
                        xdr.open("post", urlMaker(serviceEndPoint, params));
                        if (data) {
                            var requestData = serviceFactory.requestTranform(data);
                            xdr.send(requestData);
                        } else {
                            xdr.send();
                        }
                    }
                }, 0);
                return deferred.promise;
            };
        }
        else {
            makeRequest = function (serviceEndPoint, params, data, hideLoading,httpMethod,header) {

                var httpHeader={
                    "Content-Type":"application/xml"
                };

                if(cvsUtility.queryMap.enableHttpTrace == "yes"){
                    httpHeader= _.extend(httpHeader, {'pragma':CVS.Config.httpHeader['pragmaHeaderValue']});
                }
                var deferred = $q.defer();
               /* $timeout(function () {
                    deferred.resolve();
                }, getTimeout(serviceEndPoint));
                */var request = $http({
                    method: httpMethod?httpMethod:'POST',
                    url: urlMaker(serviceEndPoint, params),
                    data: serviceFactory.requestTranform(data),
                    //transformResponse: serviceFactory.responseTransform,
                    headers: httpHeader,
                    timeout: getTimeout(serviceEndPoint)
                });

                var promise = request.then(
                    function (response) {
                        return  serviceFactory.responseTransform(response.data);
                    },
                    function (response) {
                        return  serviceFactory.responseTransform(response.data);
                    }
                )['finally'](function () {

                    promise.abort = angular.noop;
                    deferred = request = promise = null;
                });

                promise.abort = function() {
                    deferred.resolve();
                };

                return promise;
            }
        }

        function urlMaker(serviceNames, params) {
            // session timer reset
            help.resetTimer();
            /*if (activeModel.authenticated && config.currentENV !== 'demo') {
                apiParamData = activeModel.portalJson.API_PARAM_DATA;
            }
            else {
                serviceEndPoints = "demo";
            }*/

            if (cvsUtility.queryMap.env=="local" && paymentAppData.serviceNameEnv && paymentAppData.serviceNameEnv[serviceNames]) {
                baseUrl = CVS.Config.serviceHost[paymentAppData.serviceNameEnv[serviceNames]];
            } else if(!baseUrl){
                baseUrl = CVS.Config.serviceHost[cvsUtility.queryMap.env];
            }

            var fetchConfigApi = function(serviceKey,tokenId,tokenType){
                if(cvsUtility.queryMap.env == "" || cvsUtility.queryMap.env == undefined || cvsUtility.queryMap.apikey =="" || cvsUtility.queryMap.apikey == undefined){
                    if(tokenType=="QReg"){
                        return "URL_ERROR";
                    }else{
                        if(tokenId == "" || tokenId==undefined)
                            return "URL_ERROR";
                    }

                }else{
                    var url = CVS.Config.serviceHost[cvsUtility.queryMap.env];

                    var appConfigs = appConfig(config);
                    var version = '2.0';//getVersion(serviceKey);
                    return url+appConfigs+version;
                }

            };

            function getVersion (serviceKey){
                if(CVS.Config && CVS.Config.version && CVS.Config.version[serviceKey]){
                    return '&version='+CVS.Config.version[serviceKey];
                }else{
                    return "&version=1.0";
                }
            };



            var appName = help.getUserAgent() == 'DESKTOP' ? 'CMK_WEB' : 'CMK_APP';


            var getKeyValue = function (key) {
                var keyValue = config.apiParams[key];
                if (apiParamData && apiParamData[key]) {
                    keyValue = apiParamData[key];
                }
                return keyValue;
            };
            var url = {
                "domain": baseUrl + paymentAppData[serviceEndPoints][serviceNames],
                "params": {
                    "serviceName": serviceNames,
                    "version" :CVS.Config && CVS.Config.version && CVS.Config.version[serviceNames]?CVS.Config.version[serviceNames]:"1.0"
                }
                /*appConfig(config),
                */
            };


            for (var key in params) {
                // remove paramerter if not required
                if(params[key]==config.parameterNotReq){
                    delete url.params[key];
                }
                else{
                    url.params[key] = params[key];
                }
            }

            return constructURL(url);

        }

        function constructURL(url) {
            var finalURL;
            finalURL = url.domain;
            // build parameters
            if (url.params) {
                var params = "?";
                params=params+appConfig(config)+'&';
                if (!Object.keys) {
                    Object.keys = function (obj) {
                        var keys = [];
                        for (var i in obj) {
                            if (obj.hasOwnProperty(i)) {
                                keys.push(i);
                            }
                        }
                        return keys;
                    };
                }
                // building params
                for (var i = 0, keys = Object.keys(url.params); i < keys.length; i++) {
                    params += (keys[i] + "=" + url.params[keys[i]] + (( i < keys.length - 1) ? "&" : ""));
                }
                // final URL with params
                finalURL += params;
            }

            return finalURL;
        }

        function appConfig(configVariable){
            return _.map(configVariable, function(val, key){
                return key+"="+val;
            }).join("&");
        }

        function showProgress(value) {
            if(value=='none'){
//                $rootScope.showSpinner = false;
            }else{
  //              $rootScope.showSpinner = true;
            }
        }

        return {
            makeRequest: makeRequest
        }


    }
]);